import {
  FETCH_INVOICES_REQUEST,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICES_FAILURE,
} from "./invoiceActionTypes";

const initialState = {
  invoices: [],
  pagination: {
    totalCount: 0,
    totalPages: 0,
    currentPage: 1,
    perPage: 10
  },
  loading: false,
  error: null,
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVOICES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_INVOICES_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        invoices: action.payload?.invoices || [],
        pagination: action.payload?.pagination || state.pagination
      };
    case FETCH_INVOICES_FAILURE:
      return { 
        ...state, 
        invoices: [], 
        loading: false, 
        error: action.payload 
      };
    default:
      return state;
  }
};

export default invoiceReducer;
